import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';

import { ICrisisActions, IThunkGetCrisisCallTeamMembers } from '../types';

const onGetCrisisCallTeamMembers: IThunkGetCrisisCallTeamMembers = thunk(
  async ({ setCrisisCallTeamMembers }: Actions<ICrisisActions>, payload) => {
    const { clinicId, onlyCrisis = false } = payload;

    const data = await api.crisis.getCrisisCallsTeamMembers(clinicId, onlyCrisis).then(r => r.data);

    setCrisisCallTeamMembers(data);

    return data;
  },
);

export default onGetCrisisCallTeamMembers;
